import { NotificationService } from 'src/app/shared/services/notification.service';
import { UserRole } from './../../follow-ups/models/deviation';

import { EmployeeServices } from './../services/employee.services';
import { HelperService } from './../../../_services/helper.service';

import {
  inject,
  ChangeDetectorRef,
  Component,
  OnInit,
  ViewChild
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';

import { EmployeePrivateDocumentServices } from './../services/employeeprivatedocument.service';
import { BaseServices } from 'src/app/kuba/kuba.services';
import { AppErrorCode, FeatureKey, Rights } from 'src/app/_models';
import { SelectItem } from 'primeng/api';
import { Table } from 'primeng/table';
import { TranslateService } from '@ngx-translate/core';
import { UploaderConfig } from 'src/app/shared/ecpl-document-explorer/uploader-config';
import { ManualService } from 'src/app/kuba/manuals/services/manual.services';
import * as _ from 'lodash';
import {
  getFileExtension,
  humanizeType
} from 'src/app/kuba/shared/helpers/file.helper';
import { Subscription } from 'rxjs';
import { QualitySystemService } from '../../quality-system/services/quality-system.service';
import { OtherSystemService } from '../../other-system/services/other-system.service';
import { InternalControlServices } from '../../internal-control/services/internal-control.service';
import { FeatureManualService } from '../../feature-documents/feature-document.services';
import {
  Department,
  DropdownOption
} from '../../businesses/models/businessDepartment';
import { PrivateDocumentUploadListResponse } from '../models/employeeDocument';
import {
  addUploadedDocuments,
  removeDocument
} from '../helpers/employee-document.helper';
import { LanguageId } from 'src/app/_models/language-id.enum';

@Component({
  selector: 'documented-training',
  templateUrl: 'employee-documented-training.component.html',
  styleUrl: 'employee-documented-training.component.scss',
  standalone: false
})
export class DocumentedTrainingComponent implements OnInit {
  private readonly notifications = inject(NotificationService);
  @ViewChild('employee') empTable: Table;
  //#region variables
  additionalData: any;
  loading = false;
  selectingManual = false;
  upConfig: UploaderConfig;
  upConfigApp: UploaderConfig;
  newDocumentAdded: any = [];
  uploadedFiles: any = [];
  docId: number;
  employeeId: number;
  editMode = false;
  addManualsEdit = true;
  addFromManuals = true;
  showSavingLoader = false;
  isEditor = false;
  isUser = false;
  featureId: any;
  selectedFiles: any;
  isMultiDocument = false;
  employees: any = [];
  emp: any = [];
  rowID: number = null!;
  isCollapsed = false;
  selectedEmployees: SelectItem[];
  selectedEmployeesForApproval: any = [];
  files: any = [];
  type: any;
  title: any = 'DOCUMENTED_TRAINING';
  typeList: any = [];
  originalEmp: any = [];
  showArchiveDocumentDailog: boolean = false;
  ShowPopUp: boolean = false;
  otherdocumentPopUp: boolean = false;
  QualitydocumentPopUp: boolean = false;
  internalControlPopUp: boolean = false;
  treeNode: any;
  treeActiveNode: any = null;
  selectedArticles: any = [];
  isDocTrainButton = true;
  hasRights = false;
  hasQualitySystem = false;
  hasOtherSystem = false;
  hasInternalControl = false;
  dropDownAlinement = false;
  manualList: SelectItem[];
  qualityList: SelectItem[];
  otherList: SelectItem[];
  internalControlList: SelectItem[];
  selectedManual: any = 543;
  apiResponse: boolean = true;
  private subscriptions: Subscription[] = [];
  isPortal: boolean;
  departmentOptions: DropdownOption[];
  hasAnyFilesChecked: boolean = false;
  currentFileSearch: string = '';
  // Documented training - "trained by" / confirm training
  selectedTrainedById: number = null!;
  currentEmployeeId: number = null!;
  trainerConfirmDate: Date = null!;
  maxTrainingDate: Date = new Date();
  selectedTrainerDocs: any[] = [];
  //#endregion

  //#region constructor
  /**
   *  constructor
   * @param route {ActivatedRoute}
   * @param privateDocSvc {EmployeePrivateDocumentServices}
   */
  constructor(
    private route: ActivatedRoute,
    private employeePrivateDocumentServices: EmployeePrivateDocumentServices,
    private employeeServices: EmployeeServices,
    private featureManualService: FeatureManualService,
    private translate: TranslateService,
    private manualservices: ManualService,
    private qualityservice: QualitySystemService,
    private otherservice: OtherSystemService,
    private internalControlService: InternalControlServices,
    private cdr: ChangeDetectorRef
  ) {
    //#endregion
    this.employeeId = route.snapshot.params['eid'];
    this.type = route.snapshot.params['mId'];
    if (this.type == 1) {
      this.title = 'DOCUMENTED_TRAINING';
      this.isMultiDocument = true;
      if (+BaseServices.roleId !== UserRole.PORTAL) {
        this.loadTrainers();
      }
      this.emp = this.route.snapshot.data['applist'];
      this.originalEmp = this.route.snapshot.data['applist'];
      this.seedExistingTrainers();
      this.subscriptions.push(
        this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
          this.typeList = [];
          this.typeList.push({ label: val.SELECT, value: null });
          var types = this.emp
            .map((item: any) => item.TypeOfEmployee)
            .filter(
              (value: any, index: any, self: any) =>
                self.indexOf(value) === index
            );
          types.forEach((element: any) => {
            this.typeList.push({ label: element, value: element });
          });
        })
      );
    }

    // Load eligible trainers in the single-employee view too, to resolve the trainer name.
    if (!this.isMultiDocument && +BaseServices.roleId !== UserRole.PORTAL) {
      this.loadTrainers();
    }

    if (BaseServices.roleId == '3') {
      if (BaseServices.userBase.UserFeatureKey == this.employeeId)
        this.isUser = true;
      else this.isEditor = true;
    }
    if (
      (BaseServices.roleId == '4' || BaseServices.roleId == '5') &&
      BaseServices.userBase.UserFeatureKey == this.employeeId
    ) {
      this.isUser = true;
    }

    if (
      BaseServices.roleId == '3' ||
      (BaseServices.roleId == '5' &&
        BaseServices.checkUserRights(Rights.DOCUMENTED_TRAINING_RIGHTS, 'User'))
    ) {
      this.hasRights = true;
    }
    // TODO: need to send dynamic values
    this.additionalData = {
      ApplicationId: BaseServices.ApplicationId,
      BusinessId: BaseServices.BusinessId,
      EmployeeId: this.employeeId,
      IsPrivateDocument: true,
      Status: '1',
      CreatedBy: BaseServices.UserId,
      CreatedOn: '',
      ModifiedBy: BaseServices.UserId,
      ModifiedOn: '',
      IsDocumentedTraining: true
    };

    this.upConfig = {
      title: 'DOCUMENTED_TRAINING',
      viewSwitch: true,
      IsDocumentedUploadButton: true,
      showDeleteButton: false,
      editMode: this.editMode,
      windowedHeight: false,
      showUserMeta: false,
      showSearchFilter: false,
      showDocumentedTrainingButton: !this.isDocTrainButton && this.hasRights,
      uploaderUri:
        environment.BASE_URL + '/file/upload/business/employee/private-docs',
      addtionalData: this.additionalData,
      isEditablePrivateDocument: true,
      pdEmpId: this.employeeId
    };
    this.upConfigApp = {
      title: '',
      titleAsLabel: true,
      editMode: true,
      windowedHeight: false,
      viewSwitch: false,
      showUserMeta: false,
      showSearchFilter: false,
      IsDocumentedUploadButton: true,
      showDeleteButton: true,
      uploaderUri:
        environment.BASE_URL + '/file/upload/business/employee/private-docs',
      addtionalData: this.additionalData,
      pdEmpId: this.employeeId
    };
  }
  /**
   * file upload events
   * @param event {any}
   */
  isFileSeclected() {
    var selected = this.uploadedFiles.filter((x: any) => x.selected == true);
    if (selected.length > 0) return false;
    else return true;
  }

  setCollapse(i: number): boolean {
    let isCollapsed = i === this.rowID;
    return !isCollapsed;
  }

  toggleClick(i: number): void {
    this.rowID = i;
    this.isCollapsed = !this.isCollapsed;
  }

  toggleClickHide(i: number): void {
    this.rowID = null!;
  }
  saveUploaded(event: any) {
    if (event == 'showDocumentDialog') {
      this.showDocumentDailog();
    } else if (event == 'showDocumentDialog1') {
      this.showQSDocumentDailog();
    } else if (event == 'showDocumentDialog2') {
      this.showOSDocumentDailog();
    } else {
      if (event) {
        let eventType = event.eventName;
        switch (eventType) {
          case 'DeleteArticle':
            {
              this.uploadedFiles = this.uploadedFiles.filter(
                (x: any) =>
                  x.id !== +event.item.data.id ||
                  (x.id == +event.item.data.id && x.documentType != 'article')
              );
              this.selectedArticles = this.selectedArticles.filter(
                (x: any) => x.id !== +event.item.data.id
              );
              this.newDocumentAdded = this.newDocumentAdded.filter(
                (x: any) => x.Path !== event.item.data.path
              );
              this.notifications.success('UI_NOTIFICATIONS.DELETED');

              if (event.item.data.id != 0) {
                this.subscriptions.push(
                  this.employeeServices
                    .deleteEmployeeDocument(event.item.data.id)
                    .subscribe()
                );
              }
            }
            break;
          case 'DeleteFile':
            this.newDocumentAdded = this.newDocumentAdded.filter(
              x => x.Path !== event.item.data.path
            );
            this.uploadedFiles = this.uploadedFiles.filter(
              x => x.path !== event.item.data.path
            );
            this.notifications.success('UI_NOTIFICATIONS.DELETED');

            if (event.item.data.id !== 0) {
              this.subscriptions.push(
                this.employeeServices
                  .deleteEmployeeDocument(event.item.data.id)
                  .subscribe()
              );
            }
            break;
          case 'DeleteChecklist':
            {
              this.uploadedFiles = this.uploadedFiles.filter(
                (x: any) =>
                  x.id !== +event.item.data.id ||
                  (x.id == +event.item.data.id && x.documentType != 'checklist')
              );
              this.selectedArticles = this.selectedArticles.filter(
                (x: any) => x.id !== +event.item.data.id
              );
              this.newDocumentAdded = this.newDocumentAdded.filter(
                (x: any) => x.Path !== event.item.data.path
              );
              this.notifications.success('UI_NOTIFICATIONS.DELETED');

              if (event.item.data.id != 0) {
                this.subscriptions.push(
                  this.employeeServices
                    .deleteEmployeeDocument(event.item.data.id)
                    .subscribe()
                );
              }
            }
            break;
          case 'DeleteDefaultFile':
            this.newDocumentAdded = this.newDocumentAdded.filter(
              (x: any) => x.Path !== event.item.data.path
            );
            this.uploadedFiles = this.uploadedFiles.filter(
              (x: any) => x.path !== event.item.data.path
            );
            this.notifications.success('UI_NOTIFICATIONS.DELETED');

            if (event.item.data.id !== 0) {
              this.subscriptions.push(
                this.employeeServices
                  .deleteEmployeeDocument(event.item.data.id)
                  .subscribe()
              );
            }
            break;
          case 'remove':
            this.uploadedFiles = this.uploadedFiles.filter(
              (x: any) => x.id !== +event.id
            );
            break;
          case 'ShowOfficeFileSaveloader':
            this.subscriptions.push(
              this.employeePrivateDocumentServices
                .updateDoc(event.item.id, this.employeeId, false)
                .subscribe(res => {
                  this.docId = event.item.id;
                  if (res) {
                    this.subscriptions.push(
                      this.employeePrivateDocumentServices
                        .list(this.employeeId, 2)
                        .subscribe(result => {
                          if (result.length > 0) {
                            this.uploadedFiles = result;
                            this.Approve(1);
                          }
                        })
                    );
                  }
                })
            );
            if (parseInt(sessionStorage.getItem('isDocumentChanged')!, null!)) {
              this.showSavingLoader = true;
              setTimeout(() => {
                this.showSavingLoader = false;
                this.newDocumentAdded = [];
              }, 15000);
              sessionStorage.setItem('isDocumentChanged', '0');
            }
            break;
          default:
            let keyBindings = {
              Originalname: 'OriginalFileName',
              FileTypeId: 'FileType'
            };
            let privateDoc = Object.assign({}, event, this.additionalData);
            privateDoc.id = 0;
            privateDoc.status = '1';
            privateDoc.createdBy = BaseServices.UserId;
            this.newDocumentAdded.push(
              HelperService.switchKeysCase(privateDoc, keyBindings)
            );

            break;
        }
      }
    }
  }

  /**
   * Saves the documented-training documents.
   * @param onSaved Called once the save has completed (or immediately when there is nothing
   * to save). The approval notification must only be sent after the documents — and their
   * "Trained by" person — are committed, otherwise the backend sees no unapproved documents.
   * @param suppressSaveToast True when the caller shows its own toast (send approval notice),
   * so the user does not get two green toasts for one action.
   */
  saveDoc(onSaved?: () => void, suppressSaveToast = false) {
    if (this.isMultiDocument == true) {
      if (
        (this.newDocumentAdded.length > 0 ||
          this.selectedArticles.length > 0) &&
        this.selectedEmployeesForApproval.length > 0
      ) {
        this.loading = true;
        this.newDocumentAdded.forEach((element: any) => {
          this.selectedEmployeesForApproval.forEach((x: any) => {
            var tempDoc: any = {};
            tempDoc.BusinessId = element.BusinessId;
            tempDoc.CreatedBy = element.CreatedBy;
            tempDoc.CreatedOn = element.CreatedOn;
            tempDoc.EmployeeId = x.EmployeeId;
            tempDoc.Extension = element.Extension;
            tempDoc.FileType = element.FileType;
            tempDoc.Filename = element.Filename;
            tempDoc.Id = element.Id;
            tempDoc.IsPrivateDocument = element.IsPrivateDocument;
            tempDoc.Mimetype = element.Mimetype;
            tempDoc.ModifiedBy = element.ModifiedBy;
            tempDoc.ModifiedOn = element.ModifiedOn;
            tempDoc.OriginalFileName = element.OriginalFileName;
            tempDoc.Path =
              element.documentType == 'videos' ? element.url : element.Path;
            tempDoc.Size = element.Size;
            tempDoc.Status = element.Status;
            tempDoc.IsDocumentedTraining = true;
            tempDoc.TrainedById = this.selectedTrainedById || null;
            tempDoc.TrainedOn = this.getSelfTrainedOn();
            this.files.push(tempDoc);
          });
        });

        this.selectedArticles.forEach((element: any) => {
          this.selectedEmployeesForApproval.forEach((x: any) => {
            var tempDoc: any = {};
            tempDoc.BusinessId = BaseServices.BusinessId;
            tempDoc.CreatedBy = BaseServices.UserId;
            tempDoc.CreatedOn = element.createdOn;
            tempDoc.EmployeeId = x.EmployeeId;
            tempDoc.Extension = null;
            tempDoc.FileType = null;
            tempDoc.Filename = element.filename;
            tempDoc.Id = element.Id;
            tempDoc.IsPrivateDocument = true;
            tempDoc.Mimetype = null;
            tempDoc.ModifiedBy = BaseServices.UserId;
            tempDoc.ModifiedOn = null;
            tempDoc.OriginalFileName = element.originalFileName;
            tempDoc.Path = null;
            tempDoc.Size = null;
            tempDoc.Status = 1;
            tempDoc.DocumentTypeId = element.documentTypeId;
            tempDoc.DocumentType = element.documentType;
            tempDoc.Path =
              element.documentType == 'videos' ? element.url : element.path;
            tempDoc.DocumentId = element.nodeId;
            tempDoc.documentType = element.documentType;
            tempDoc.IsDocumentedTraining = true;
            tempDoc.TrainedById = this.selectedTrainedById || null;
            tempDoc.TrainedOn = this.getSelfTrainedOn();
            this.files.push(tempDoc);
          });
        });
        this.subscriptions.push(
          this.employeePrivateDocumentServices.saveDocs(this.files).subscribe({
            next: result => {
              if (result) {
                if (!suppressSaveToast) {
                  this.notifications.success('UI_NOTIFICATIONS.SAVED');
                }
                this.newDocumentAdded = [];
                this.selectedArticles = [];
                this.selectedEmployeesForApproval = [];
                this.selectedTrainedById = null!;
                this.uploadedFiles = [];
                this.files = [];
                this.addUploadedDocumentsToEmployees(result);
                onSaved?.();
              }
            },
            error: () => {
              this.loading = false;
              this.files = [];
            }
          })
        );
      } else {
        // Nothing new to save — notify against the already-saved documents
        onSaved?.();
      }
    } else {
      // Single employee view: the save may fire up to two requests, so only signal
      // the caller once both have finished.
      let pendingSaves = 0;
      const saveFinished = () => {
        pendingSaves--;
        if (pendingSaves <= 0) {
          onSaved?.();
        }
      };
      if (this.selectedArticles.length > 0) {
        var temp: any = [];
        this.selectedArticles.forEach((element: any) => {
          this.loading = true;
          var tempDoc: any = {};
          tempDoc.CreatedOn = element.createdOn;
          tempDoc.EmployeeId = Number(this.employeeId);
          tempDoc.Extension = null;
          tempDoc.FileType = null;
          tempDoc.Filename = element.filename;
          tempDoc.Id = element.Id;
          tempDoc.IsPrivateDocument = true;
          tempDoc.Mimetype = null;
          tempDoc.ModifiedBy = null;
          tempDoc.ModifiedOn = null;
          tempDoc.OriginalFileName = element.originalFileName;
          tempDoc.Path = null;
          tempDoc.Size = null;
          tempDoc.Status = 1;
          tempDoc.DocumentTypeId = element.documentTypeId;
          tempDoc.Path =
            element.documentType == 'videos' ? element.url : element.path;
          tempDoc.DocumentId = element.nodeId;
          tempDoc.DocumentType = element.documentType;
          tempDoc.CreatedBy = Number(BaseServices.UserId);
          tempDoc.IsDocumentedTraining = true;
          temp.push(tempDoc);
        });
        pendingSaves++;
        this.subscriptions.push(
          this.employeePrivateDocumentServices
            .save(temp, this.employeeId)
            .subscribe({
              next: result => {
                if (result) {
                  if (!suppressSaveToast) {
                    this.notifications.success('UI_NOTIFICATIONS.SAVED');
                  }
                  this.loading = false;
                  this.selectedArticles = [];
                  this.getDoc();
                }
                saveFinished();
              },
              error: () => {
                this.loading = false;
              }
            })
        );
      }

      if (this.newDocumentAdded.length > 0) {
        this.loading = true;
        this.newDocumentAdded.forEach((element: any) => {
          element.IsDocumentedTraining = true;
        });
        pendingSaves++;
        this.subscriptions.push(
          this.employeePrivateDocumentServices
            .save(this.newDocumentAdded, this.employeeId)
            .subscribe({
              next: result => {
                if (result) {
                  if (!suppressSaveToast) {
                    this.notifications.success('UI_NOTIFICATIONS.SAVED');
                  }
                  this.loading = false;
                  this.newDocumentAdded = [];
                  this.getDoc();
                }
                saveFinished();
              },
              error: () => {
                this.loading = false;
              }
            })
        );
      }

      if (pendingSaves === 0) {
        onSaved?.();
      }
    }
  }

  //#endregion

  //#region page-events
  /**
   * page initialization
   */
  ngOnInit() {
    BaseServices.setActiveTreeNode(null);
    this.isPortal = +BaseServices.roleId === UserRole.PORTAL ? true : false;

    if (this.isPortal) {
      const portalUploadData = {
        ApplicationId: BaseServices.ApplicationId,
        PortalId: BaseServices.PortalId
      };

      this.upConfigApp.uploaderUri =
        environment.BASE_URL + '/file/upload/portal/employee/private-docs';

      this.upConfigApp.addtionalData = portalUploadData;
    }

    this.treeActiveNode = null;
    this.currentEmployeeId = +BaseServices.userBase.UserFeatureKey;
    let uploadfiles = this.route.snapshot.data['list'];
    if (uploadfiles && uploadfiles.length > 0) {
      this.uploadedFiles = uploadfiles;
    }
    this.enrichTrainerNames();
    this.setupDepartmentsDropdown();
    this.checkActiveFeatures();
  }

  /**
   * Documented training: documents for which the logged-in user is the registered
   * "trained by" person and the training has not yet been confirmed. Shown in the single
   * employee view so the trainer can confirm the training was given.
   */
  get trainerPendingDocs(): any[] {
    if (!this.uploadedFiles || this.currentEmployeeId == null) {
      return [];
    }
    // The single-employee list endpoint serializes as camelCase, while other endpoints use
    // PascalCase — normalize both so the panel works regardless of the source.
    return this.uploadedFiles
      .map((doc: any) => ({
        id: doc.Id ?? doc.id,
        filename:
          doc.OriginalFileName ??
          doc.originalFileName ??
          doc.Filename ??
          doc.filename,
        trainedById: doc.TrainedById ?? doc.trainedById,
        trainedOn: doc.TrainedOn ?? doc.trainedOn
      }))
      .filter(
        (doc: any) =>
          doc.trainedById === this.currentEmployeeId && !doc.trainedOn
      );
  }

  /**
   * Shortcut: when the boss selects themselves as the "trained by" person the training date
   * is auto-populated at save time (no trainer email / manual confirmation step). Returns today as
   * an ISO date string, or null when the trainer is someone else.
   * @param trainedById The chosen trainer, the one selected for new documents by default
   */
  private getSelfTrainedOn(
    trainedById: number = this.selectedTrainedById
  ): string | null {
    if (trainedById && trainedById === this.currentEmployeeId) {
      const d = new Date();
      return (
        `${d.getFullYear()}-` +
        `${String(d.getMonth() + 1).padStart(2, '0')}-` +
        `${String(d.getDate()).padStart(2, '0')}`
      );
    }
    return null;
  }

  getEmployeeName(employeeId: number): string {
    if (!employeeId || !this.employees) {
      return '';
    }
    const match = this.employees.find((e: any) => e.value === employeeId);
    return match ? match.label : '';
  }

  /**
   * Adds the resolved trainer name (and a camelCase trainedOn) onto each uploaded file, so the
   * documented-training file list can show the "Trained by" / "Trained on" columns.
   */
  private enrichTrainerNames(): void {
    if (!this.uploadedFiles || !this.employees || this.employees.length === 0) {
      return;
    }
    this.uploadedFiles.forEach((f: any) => {
      const trainedById = f.trainedById ?? f.TrainedById;
      f.trainedByName = trainedById ? this.getEmployeeName(trainedById) : '';
      if (f.trainedOn == null && f.TrainedOn != null) {
        f.trainedOn = f.TrainedOn;
      }
    });
  }

  /**
   * Loads the employees eligible to be "trained by" (editors + users with the
   * "Administrate documented training" right), used as the dropdown options and to resolve names.
   */
  private loadTrainers(): void {
    this.subscriptions.push(
      this.employeePrivateDocumentServices
        .getDocumentedTrainingTrainers(BaseServices.BusinessId)
        .subscribe((result: any) => {
          if (result) {
            this.employees = result.map((t: any) => ({
              label: t.Name,
              value: t.Id
            }));
            this.enrichTrainerNames();
          }
        })
    );
  }

  /** Formats a date as an ISO yyyy-MM-dd string (no timezone shift). */
  private toIsoDate(d: Date): string {
    return (
      `${d.getFullYear()}-` +
      `${String(d.getMonth() + 1).padStart(2, '0')}-` +
      `${String(d.getDate()).padStart(2, '0')}`
    );
  }

  /**
   * True when the logged-in user is the registered trainer of the document and the training
   * has not yet been confirmed. Controls the inline "Confirm training" control in the document grid.
   */
  canConfirmTraining(document: any): boolean {
    if (!document) {
      return false;
    }
    const trainedById = document.TrainedById ?? document.trainedById;
    const trainedOn = document.TrainedOn ?? document.trainedOn;
    return trainedById === this.currentEmployeeId && !trainedOn;
  }

  /** Per-document training date chosen inline in the document grid, keyed by document id. */
  inlineTrainingDates: { [documentId: number]: Date } = {};

  /** Trainer chosen for an existing document in the grid, keyed by document id. */
  existingTrainedBy: { [documentId: number]: number } = {};

  /**
   * True while the training of the document has not been confirmed, so a "Trained by" person
   * can still be chosen for it. Documents uploaded before the trainer could be selected have no
   * trainer at all, and this is how they get one.
   */
  canAssignTrainer(document: any): boolean {
    if (!document) {
      return false;
    }
    return !(document.TrainedOn ?? document.trainedOn);
  }

  /**
   * Trainers picked in the grid but not stored yet, keyed by document id. Recorded as the
   * user selects, rather than derived from the document list, so it does not depend on which list
   * the grid was rendered from.
   */
  private pendingTrainerChanges: { [documentId: number]: number } = {};

  /**
   * The trainer each document had when it was loaded, so a selection can be compared against
   * what is stored. Kept separately because the grid rows are not reloaded between saves.
   */
  private storedTrainedBy: { [documentId: number]: number | null } = {};

  /**
   * Records the trainer chosen for a single document. Clearing the dropdown, or picking the
   * trainer the document already has, drops it from the pending changes again.
   * @param document The document the trainer was chosen for
   */
  onTrainerSelected(document: any, selected: number | null): void {
    const documentId = document?.Id ?? document?.id;
    if (!documentId) {
      return;
    }

    // Remember what the document was loaded with, so the selection can still be compared against
    // the stored trainer after an earlier save attempt.
    if (!(documentId in this.storedTrainedBy)) {
      this.storedTrainedBy[documentId] =
        document.TrainedById ?? document.trainedById ?? null;
    }

    if (selected && selected !== this.storedTrainedBy[documentId]) {
      this.pendingTrainerChanges[documentId] = selected;
    } else {
      delete this.pendingTrainerChanges[documentId];
    }
  }

  /**
   * The trainer selections the user has made on existing documents, one entry per document so
   * documents given different trainers are each updated with their own.
   */
  private collectTrainerAssignments(): {
    documentId: number;
    trainedById: number;
  }[] {
    return Object.keys(this.pendingTrainerChanges).map(documentId => ({
      documentId: +documentId,
      trainedById: this.pendingTrainerChanges[+documentId]
    }));
  }

  /**
   * Preselects the trainer already registered on documents whose training is still pending,
   * so the dropdown shows what is stored rather than an empty value.
   */
  private seedExistingTrainers(): void {
    this.existingTrainedBy = {};
    this.pendingTrainerChanges = {};
    this.storedTrainedBy = {};
    (this.emp || []).forEach((employee: any) => {
      (employee.EmployeeDocuments || []).forEach((document: any) => {
        const trainedById =
          document.TrainedById ?? document.trainedById ?? null;
        if (!this.canAssignTrainer(document)) {
          return;
        }
        this.storedTrainedBy[document.Id] = trainedById;
        if (trainedById) {
          this.existingTrainedBy[document.Id] = trainedById;
        }
      });
    });
  }

  /**
   * Adds the documents returned from the multi-document save to their employees, so the grid shows
   * them without reloading the whole list. The save response carries no creator, so every document
   * is attributed to the logged-in user.
   * @param uploadedDocuments The saved documents, one entry per document and employee
   */
  private addUploadedDocumentsToEmployees(
    uploadedDocuments: PrivateDocumentUploadListResponse[]
  ): void {
    addUploadedDocuments(
      this.originalEmp,
      uploadedDocuments,
      BaseServices.Name
    ).forEach(document => {
      // Same trainer bookkeeping as seedExistingTrainers, without resetting pending selections.
      if (this.canAssignTrainer(document)) {
        this.storedTrainedBy[document.Id] = document.TrainedById;
        if (document.TrainedById) {
          this.existingTrainedBy[document.Id] = document.TrainedById;
        }
      }
    });

    // Re-apply the filename search so a filtered view includes the new documents too.
    this.filterResults(this.currentFileSearch);
  }

  /**
   * Removes a deleted document from its employee, so the grid reflects the deletion without
   * reloading the whole list.
   * @param documentId The deleted document
   */
  private removeDeletedDocument(documentId: number): void {
    removeDocument(this.originalEmp || [], documentId);

    delete this.pendingTrainerChanges[documentId];
    delete this.storedTrainedBy[documentId];
    delete this.existingTrainedBy[documentId];
    delete this.inlineTrainingDates[documentId];

    // A filtered view holds its own copies of the document arrays, so rebuild it.
    this.filterResults(this.currentFileSearch);
  }

  /**
   * Applies stored trainer assignments to the documents in the grid, so it reflects them
   * without reloading the whole list. Choosing yourself registers the training right away, as the
   * backend does.
   * @param assignments The trainer assignments the backend has stored
   */
  private applyTrainerAssignments(
    assignments: { documentId: number; trainedById: number }[]
  ): void {
    const trainerByDocumentId = new Map(
      assignments.map(a => [a.documentId, a.trainedById])
    );
    // Documents are updated in place: a filtered view holds the same document objects.
    (this.originalEmp || []).forEach((employee: any) => {
      (employee.EmployeeDocuments || []).forEach((document: any) => {
        const trainedById = trainerByDocumentId.get(document.Id);
        if (trainedById === undefined) {
          return;
        }
        document.TrainedById = trainedById;
        document.TrainedOn = this.getSelfTrainedOn(trainedById);
        this.storedTrainedBy[document.Id] = trainedById;
        this.existingTrainedBy[document.Id] = trainedById;
      });
    });
  }

  /** True when a trainer has been chosen for an existing document but not stored yet. */
  get hasPendingTrainerAssignments(): boolean {
    return this.collectTrainerAssignments().length > 0;
  }

  /**
   * Registers the chosen trainers on existing documents before continuing. The trainers have
   * to be stored first, otherwise the approval notice cannot pick them up for the trainer email.
   * @param onDone Called once the trainers are stored, or right away when none were chosen
   * @param notifyTrainers False when the approval notice follows, which emails the trainers itself
   */
  private saveTrainerAssignments(
    onDone: () => void,
    notifyTrainers = true
  ): void {
    const assignments = this.collectTrainerAssignments();
    if (assignments.length === 0) {
      onDone();
      return;
    }

    this.subscriptions.push(
      this.employeePrivateDocumentServices
        .assignTrainer(assignments, notifyTrainers)
        .subscribe({
          next: () => {
            this.pendingTrainerChanges = {};
            this.applyTrainerAssignments(assignments);
            onDone();
          },
          error: (err: HttpErrorResponse) => {
            this.loading = false;
            if (err.error?.Detail) {
              this.notifications.add({
                severity: 'error',
                summary: this.translate.instant(
                  'GENERAL_ERROR.UNEXPECTED_ERROR_TITLE',
                  {
                    status: err.status
                  }
                ),
                detail: err.error.Detail
              });
            } else {
              this.showGenericErrorToast(err.status);
            }
          }
        })
    );
  }

  /**
   * Save in the documented-training list: stores newly added documents and any trainer chosen
   * for documents that were uploaded without one. Selecting yourself registers the training right
   * away, any other trainer is emailed when the approval notice is sent.
   */
  saveDocumentsAndTrainers(): void {
    // The save toast is raised here instead of inside saveDoc, so one click gives one toast
    // whether it stored documents, trainers, or both.
    this.saveDoc(() => {
      this.saveTrainerAssignments(() => {
        this.notifications.success('UI_NOTIFICATIONS.SAVED');
        this.loading = false;
      });
    }, true);
  }

  /**
   * Confirms training for a single document from the inline grid control, on the chosen date.
   */
  confirmSingleTraining(document: any): void {
    const docId = document.Id ?? document.id;
    const date = this.inlineTrainingDates[docId];
    if (!date) {
      return;
    }
    const trainedOn = this.toIsoDate(date);
    this.loading = true;
    this.subscriptions.push(
      this.employeePrivateDocumentServices
        .confirmTraining([docId], trainedOn)
        .subscribe({
          next: () => {
            this.notifications.success('UI_NOTIFICATIONS.APPROVED');
            this.loading = false;
            delete this.inlineTrainingDates[docId];
            this.applyConfirmedTraining(docId, trainedOn);
          },
          error: (err: HttpErrorResponse) => {
            this.loading = false;
            this.showGenericErrorToast(err.status);
          }
        })
    );
  }

  /**
   * Applies a confirmed training to the document in the grid, so it reflects it without
   * reloading the whole list. A confirmed training keeps its trainer, so the document also leaves
   * the trainer bookkeeping, as seedExistingTrainers would leave it out.
   * @param documentId The document whose training was confirmed
   * @param trainedOn The confirmed training date, as an ISO date string
   */
  private applyConfirmedTraining(documentId: number, trainedOn: string): void {
    // Updated in place: a filtered view holds the same document objects.
    (this.originalEmp || []).forEach((employee: any) => {
      (employee.EmployeeDocuments || []).forEach((document: any) => {
        if (document.Id === documentId) {
          document.TrainedOn = trainedOn;
        }
      });
    });
    delete this.pendingTrainerChanges[documentId];
    delete this.storedTrainedBy[documentId];
    delete this.existingTrainedBy[documentId];
  }

  /**
   * Confirms, on behalf of the registered trainer, that the selected documented-training
   * documents were given on the chosen date.
   */
  confirmTrainingGiven(): void {
    if (!this.trainerConfirmDate) {
      this.showGenericErrorToast(0);
      return;
    }
    const documentIds = this.selectedTrainerDocs.map(
      (doc: any) => doc.id ?? doc.Id
    );
    if (documentIds.length === 0) {
      return;
    }
    const d = this.trainerConfirmDate;
    const trainedOn =
      `${d.getFullYear()}-` +
      `${String(d.getMonth() + 1).padStart(2, '0')}-` +
      `${String(d.getDate()).padStart(2, '0')}`;
    this.loading = true;
    this.subscriptions.push(
      this.employeePrivateDocumentServices
        .confirmTraining(documentIds, trainedOn)
        .subscribe({
          next: () => {
            this.notifications.success('UI_NOTIFICATIONS.APPROVED');
            this.loading = false;
            this.selectedTrainerDocs = [];
            this.trainerConfirmDate = null!;
            this.getDoc();
          },
          error: (err: HttpErrorResponse) => {
            this.loading = false;
            this.showGenericErrorToast(err.status);
          }
        })
    );
  }

  private checkActiveFeatures() {
    const leftNavStr = sessionStorage.getItem('leftNav');
    if (!leftNavStr) return;
    const leftNav: any[] = JSON.parse(leftNavStr);
    this.hasQualitySystem = leftNav.some(
      (item: any) => item.id === FeatureKey.QUALITY_SYSTEMS
    );
    this.hasOtherSystem = leftNav.some(
      (item: any) => item.id === FeatureKey.OTHER_SYSTEMS
    );
    this.hasInternalControl = leftNav.some(
      (item: any) => item.id === FeatureKey.INTERNAL_CONTROL
    );
  }

  getDoc() {
    this.loading = true;
    this.subscriptions.push(
      this.employeePrivateDocumentServices.list(this.employeeId, 2).subscribe({
        next: result => {
          this.uploadedFiles = result;
          this.enrichTrainerNames();
          this.loading = false;
        },
        error: () => {
          this.loading = false;
        }
      })
    );
  }
  toggleEditMode(mode: any) {
    this.editMode = mode;
    this.upConfig.editMode = mode;
    this.upConfig.showDeleteButton = mode;
  }

  onTableHeaderCheckboxToggle() {
    this.selectedEmployeesForApproval = this.emp;
  }
  setupDepartmentsDropdown(): void {
    const departmentsFromRoute: Department[] =
      this.route.snapshot.data['busDepartment'];

    this.subscriptions.push(
      this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
        this.departmentOptions = [];
        this.departmentOptions.push({ label: val.SELECT, value: null });
      })
    );

    if (departmentsFromRoute) {
      departmentsFromRoute.forEach((department: Department) => {
        this.departmentOptions.push({
          label: department.Name,
          value: department.Name
        });
      });
    }
  }

  /**
   * Returns true if the document has not yet been approved.
   * Used to determine if the Send Approval Notice button should be enabled.
   */
  hasUnapprovedDocument = (doc: any) => doc.approvedOn == null;

  /**
   * Returns true if the employee has at least one unapproved document.
   * Used to disable the Send Approval Notice button in multi-doc view.
   */
  hasDocumentsForApproval = (emp: any) =>
    emp.TotalApprovedDocuments < emp.TotalDocuments;

  Approve(isSendApproval: number) {
    if (this.type == 1) {
      // Multi-doc view — send approval notification to selected employees with unapproved documents
      this.loading = true;
      // No frontend filter — backend filters out employees with no unapproved documents
      // and returns 404 if none exist. Filtering here causes a bug where uploading a new
      // file for a fully-approved employee (2/2) skips the notification because the local
      // approval counts haven't updated yet.
      // Captured before the save, which clears the selection.
      const employeeIds = this.selectedEmployeesForApproval.map((emp: any) => ({
        employeeId: emp.EmployeeId
      }));
      // Save first, then notify — sending in parallel with the save made the backend
      // read the documents before they were committed ("No documents to approve"), and the
      // registered trainer was never picked up for the trainer email.
      this.saveDoc(() => {
        // Register the trainers picked for existing documents before notifying, so they are
        // included in the same trainer email as newly uploaded ones.
        this.saveTrainerAssignments(() => {
          if (employeeIds.length > 0) {
            this.loading = true;
            this.subscriptions.push(
              this.employeePrivateDocumentServices
                .sendApprovalRequest(employeeIds, true)
                .subscribe({
                  next: () => {
                    this.notifications.success(
                      'UI_NOTIFICATIONS.APPROVAL_SENT'
                    );
                    this.selectedEmployeesForApproval = [];
                    this.selectedTrainedById = null!;
                    this.loading = false;
                  },
                  error: (err: HttpErrorResponse) => {
                    this.loading = false;
                    if (err.status === 404) this.showNoDocumentsToast();
                    else if (err.error?.Code === AppErrorCode.UserLacksEmail)
                      this.showMissingEmailToast(err.error.Detail);
                    else this.showGenericErrorToast(err.status);
                  }
                })
            );
          } else {
            this.selectedEmployeesForApproval = [];
            this.selectedTrainedById = null!;
            this.loading = false;
          }
        }, false);
      }, true);
    } else {
      // Single employee view
      this.loading = true;
      if (isSendApproval === 1) {
        // Editor/admin sending approval notification — no file selection required.
        // Same ordering as above: the documents must be saved before we notify.
        this.saveDoc(() => {
          this.loading = true;
          this.subscriptions.push(
            this.employeePrivateDocumentServices
              .sendApprovalRequest([{ employeeId: this.employeeId }], true)
              .subscribe({
                next: () => {
                  this.notifications.success('UI_NOTIFICATIONS.APPROVAL_SENT');
                  this.loading = false;
                },
                error: (err: HttpErrorResponse) => {
                  this.loading = false;
                  if (err.status === 404) this.showNoDocumentsToast();
                  else if (err.error?.Code === AppErrorCode.UserLacksEmail)
                    this.showMissingEmailToast(err.error.Detail);
                  else this.showGenericErrorToast(err.status);
                }
              })
          );
        }, true);
      } else {
        this.saveDoc();
        // Employee approving their own selected documents (isSendApproval === 3)
        if (this.docId != null) {
          this.selectedFiles = this.uploadedFiles.filter(
            (x: any) => x.id == this.docId
          );
        } else {
          this.selectedFiles = this.uploadedFiles.filter(
            (x: any) => x.selected == true
          );
        }
        if (this.selectedFiles.length > 0) {
          const documentIds = this.selectedFiles.map((x: any) => ({
            documentId: x.id
          }));
          this.subscriptions.push(
            this.employeePrivateDocumentServices
              .approveDocuments(documentIds)
              .subscribe({
                next: () => {
                  this.notifications.success('UI_NOTIFICATIONS.APPROVED');
                  this.loading = false;
                  this.getDoc();
                },
                error: (err: HttpErrorResponse) => {
                  this.loading = false;
                  this.showGenericErrorToast(err.status);
                }
              })
          );
        } else {
          this.loading = false;
        }
      }
    }
  }

  private showNoDocumentsToast(): void {
    const lang = sessionStorage.getItem('languageMode');
    const summary =
      lang === 'no-NO'
        ? 'Ingen dokumenter'
        : lang === 'sv-SE'
          ? 'Inga dokument'
          : 'No documents';
    const detail =
      lang === 'no-NO'
        ? 'Den ansatte har ingen dokumenter som venter på godkjenning'
        : lang === 'sv-SE'
          ? 'Den anställde har inga dokument som väntar på godkännande'
          : 'The employee has no documents awaiting approval';
    this.notifications.add({
      severity: 'warn',
      summary: summary,
      detail: detail
    });
  }

  private showMissingEmailToast(detail: string): void {
    const lang = sessionStorage.getItem('languageMode');
    const summary =
      lang === 'no-NO'
        ? 'Manglende e-postadresse'
        : lang === 'sv-SE'
          ? 'Saknar e-postadress'
          : 'Missing email address';
    this.notifications.add({
      severity: 'warn',
      summary: summary,
      detail: detail
    });
  }

  private showGenericErrorToast(status: number): void {
    this.notifications.add({
      severity: 'error',
      summary: this.translate.instant('GENERAL_ERROR.UNEXPECTED_ERROR_TITLE', {
        status
      }),
      detail: this.translate.instant('GENERAL_ERROR.UNEXPECTED_ERROR_MESSAGE', {
        status,
        technicalSupport: this.translate.instant(
          'PLEASE_CONTACT_TECHNICAL_TEAM'
        )
      })
    });
  }

  getFileExtension(filename: string): string {
    return getFileExtension(filename);
  }

  humanizeType(mimetype: string): string {
    return humanizeType(mimetype);
  }

  filterResults(data: any) {
    this.currentFileSearch = data || '';
    if (data == null || data == '') {
      this.emp = this.originalEmp;
    } else {
      var arr: any = [];
      var q = data.toLowerCase();
      this.originalEmp.forEach((x: any) => {
        var filter = [];
        if (x.EmployeeDocuments != null && x.EmployeeDocuments.length > 0) {
          x.EmployeeDocuments.forEach((ele: any) => {
            if (ele.Filename != null && ele.Filename.toLowerCase().includes(q))
              filter.push(ele);
          });
          if (filter.length > 0) {
            arr.push({ ...x, EmployeeDocuments: filter });
          }
        }
      });
      this.emp = arr;
    }
  }

  exportReport(format: 'xlsx' | 'docx' | 'pdf') {
    const businessId = BaseServices.BusinessId || 0;
    const portalId = +BaseServices.PortalId || 0;
    const langId = +BaseServices.userLanguageId || LanguageId.English;
    const visibleEmp: any[] = this.empTable?.filteredValue ?? this.emp;
    const filteredEmployeeIds = visibleEmp
      .map((e: any) => e.EmployeeId)
      .filter(Boolean);
    // Only send documentIds when filename search is active — otherwise employeeIds filter is sufficient
    const filteredDocumentIds: number[] = this.currentFileSearch
      ? visibleEmp
          .flatMap((e: any) => e.EmployeeDocuments || [])
          .map((d: any) => d.Id)
          .filter((id: any) => id > 0)
      : [];
    const ext = format;
    this.subscriptions.push(
      this.employeePrivateDocumentServices
        .exportDocumentedTraining(
          businessId,
          portalId,
          langId,
          format,
          filteredEmployeeIds,
          filteredDocumentIds
        )
        .subscribe((blob: Blob) => {
          const filename =
            this.translate.instant('DOCUMENTED_TRAINING') +
            '_' +
            new Date().toISOString().slice(0, 10) +
            '.' +
            ext;
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        })
    );
  }
  showDocumentDailog() {
    this.featureId = FeatureKey.MANUALS;
    this.selectedManual = null;
    this.treeNode = [];
    this.showArchiveDocumentDailog = false;
    this.dropDownAlinement = true;

    this.binddetails();
    this.ShowPopUp = true;
    this.hasAnyFilesChecked = false; // Reset flag when opening dialog

    setTimeout(() => this.cdr.detectChanges());
  }
  showQSDocumentDailog() {
    this.featureId = FeatureKey.QUALITY_SYSTEMS;
    this.selectedManual = null;
    this.treeNode = [];
    this.showArchiveDocumentDailog = false;
    this.dropDownAlinement = true;

    this.bindQsdetails();
    this.QualitydocumentPopUp = true;
    this.hasAnyFilesChecked = false; // Reset flag when opening dialog
    setTimeout(() => this.cdr.detectChanges());
  }

  showOSDocumentDailog() {
    this.featureId = FeatureKey.OTHER_SYSTEMS;
    this.selectedManual = null;
    this.treeNode = [];
    this.showArchiveDocumentDailog = false;
    this.dropDownAlinement = true;

    this.bindOsdetails();
    this.otherdocumentPopUp = true;
    this.hasAnyFilesChecked = false; // Reset flag when opening dialog
    setTimeout(() => this.cdr.detectChanges());
  }

  showICDocumentDailog() {
    this.featureId = FeatureKey.INTERNAL_CONTROL;
    this.selectedManual = null;
    this.treeNode = [];
    this.showArchiveDocumentDailog = false;
    this.dropDownAlinement = true;

    this.bindICdetails();
    this.internalControlPopUp = true;
    this.hasAnyFilesChecked = false;
    setTimeout(() => this.cdr.detectChanges());
  }

  catchEvent(event: any): void {
    if (event.eventName == 'CheckBoxStatus') {
      const nodeId = event.node?.data?.id;
      const newStatus = event.node?.data?.status;

      if (nodeId) {
        // Find the actual node in our treeNode reference
        const targetNode = this.findNodeById(this.treeNode, nodeId);
        if (targetNode) {
          if (targetNode.nodes != null && targetNode.nodes.length > 0) {
            this.updateStatus(targetNode.nodes, newStatus);
          }
          targetNode.status = Number(newStatus);
        } else {
          console.warn(
            'DocumentedTraining: Could not find node with ID',
            nodeId,
            'in treeNode'
          );
          // Fallback: update the event data itself (previous behavior)
          if (
            event.node.data.nodes != null &&
            event.node.data.nodes.length > 0
          ) {
            this.updateStatus(event.node.data.nodes, newStatus);
          } else {
            this.updateStatus(event.node.data, newStatus);
          }
        }
      }

      // Update flag for button state
      this.hasAnyFilesChecked = this.checkForCheckedFiles(this.treeNode);
      // Trigger change detection so button state updates
      this.cdr.detectChanges();
    }
  }

  private findNodeById(nodes: any[], id: any): any {
    if (!nodes || !Array.isArray(nodes)) return null;
    for (const node of nodes) {
      if (node.id === id) return node;
      if (node.nodes && node.nodes.length > 0) {
        const found = this.findNodeById(node.nodes, id);
        if (found) return found;
      }
      if (node.children && node.children.length > 0) {
        const found = this.findNodeById(node.children, id);
        if (found) return found;
      }
    }
    return null;
  }

  getAllArticles(allData: any) {
    allData.forEach((x: any) => {
      if (x.isFolder == 1) {
        this.getAllArticles(x.nodes);
      } else {
        if (x.isFolder == 0) {
          if (
            this.selectedArticles.find((result: any) => result.id == x.id) ==
            null
          ) {
            this.selectedArticles.push(x);
          }
        }
      }
    });
    return allData;
  }

  removeAllArticles(allData: any) {
    allData.forEach((x: any) => {
      if (x.isFolder == 1) {
        this.removeAllArticles(x.nodes);
      } else {
        if (x.isFolder == 0) {
          if (
            this.selectedArticles.filter((result: any) => result.id == x.id) !=
            null
          ) {
            var index = this.selectedArticles.findIndex(
              (res: any) => res.id == x.id
            );
            this.selectedArticles.splice(index, 1);
          }
        }
      }
    });
    return allData;
  }

  addArticlesToPrivateDocs() {
    this.showArchiveDocumentDailog = false;
    this.ShowPopUp = false;
    this.otherdocumentPopUp = false;
    this.QualitydocumentPopUp = false;
    this.internalControlPopUp = false;
    const newlySelectedFiles: any[] = [];
    this.add(this.treeNode, newlySelectedFiles);
    newlySelectedFiles.forEach((newFile: any) => {
      const exists = this.selectedArticles.some((existing: any) => {
        if (existing.nodeId && newFile.nodeId) {
          return existing.nodeId === newFile.nodeId;
        }
        return (
          existing.id === newFile.id &&
          existing.documentType === newFile.documentType
        );
      });

      if (!exists) {
        this.selectedArticles.push(newFile);
        this.uploadedFiles.push(newFile);
      }
    });
  }

  add(data: any, targetArray: any[]) {
    if (!data) return;

    data.forEach((element: any) => {
      const isFolder =
        element.type === 'folder' ||
        element.isFolder === 1 ||
        element.isFolder === true;
      const isFile =
        element.type === 'file' ||
        element.isFolder === 0 ||
        element.isFolder === false;

      if (isFolder) {
        this.add(element.nodes, targetArray);
      } else if (isFile && element.status == 1) {
        targetArray.push(element);
      }
    });
  }
  private flattenArrObj(arr: any) {
    let newArr: any = [];
    if (Array.isArray(arr) && arr.length > 0) {
      arr.forEach(element => {
        newArr.push(element);
        if (Array.isArray(element.nodes) && element.nodes.length > 0) {
          newArr = newArr.concat(this.flattenArrObj(element.nodes));
        }
      });
    }
    return newArr;
  }

  updateStatus(data: any, status: any) {
    if (Array.isArray(data)) {
      data.forEach((element: any) => {
        element.status = Number(status);
        if (element.nodes != null && element.nodes.length > 0) {
          this.updateStatus(element.nodes, status);
        }
      });
    } else if (data && typeof data === 'object') {
      data.status = Number(status);
      if (data.nodes != null && data.nodes.length > 0) {
        this.updateStatus(data.nodes, status);
      }
    }
  }
  nodeStatusChangeFunction(treedatas: any) {
    treedatas.forEach((element: any) => {
      element.status = 2;
      if (element.nodes != null && element.nodes.length > 0) {
        this.nodeStatusChangeFunction(element.nodes);
      }
    });
  }

  hasCheckedFiles(): boolean {
    // If we have any selected articles already, the button should be enabled
    if (this.selectedArticles && this.selectedArticles.length > 0) return true;

    // Fallback to scanning the tree
    return this.hasAnyFilesChecked;
  }

  private checkForCheckedFiles(nodes: any[]): boolean {
    if (!nodes || !Array.isArray(nodes) || nodes.length === 0) return false;

    for (const node of nodes) {
      // A node is a file if it has no children units or is explicitly marked as not a folder
      const isFolder =
        node.isFolder === 1 ||
        node.isFolder === true ||
        node.type === 'folder' ||
        (node.nodes && node.nodes.length > 0);
      const isFile =
        !isFolder ||
        node.type === 'file' ||
        node.isFolder === 0 ||
        node.isFolder === false;

      if (isFile && node.status === 1) {
        return true;
      }

      // Try scanning both 'nodes' and 'children' just in case
      const childArray = node.nodes || node.children;
      if (childArray && Array.isArray(childArray) && childArray.length > 0) {
        if (this.checkForCheckedFiles(childArray)) {
          return true;
        }
      }
    }
    return false;
  }

  /**
   * Deletes a document and removes it locally from the list if the request is successful
   * @param id ID of document to delete
   */
  deleteDoc(id: number) {
    this.loading = true;
    this.subscriptions.push(
      this.employeePrivateDocumentServices.delete(id).subscribe({
        next: () => {
          this.loading = false;
          this.notifications.success('UI_NOTIFICATIONS.DELETED');
          this.selectedArticles = [];
          this.removeDeletedDocument(id);
        },
        error: () => {
          this.loading = false;
        }
      })
    );
  }

  // p-select keeps its options in a signal, so each list must be assigned a
  // new array; pushing into the existing one leaves the selected label stale.
  private toSelectItems(result: any): SelectItem[] {
    return (result ?? []).map((item: any) => ({
      label: item.Title,
      value: item.Id
    }));
  }

  binddetails() {
    this.manualList = [];
    const manuals = this.manualservices
      .getManualsDocumentTraining(BaseServices.BusinessId)
      .subscribe((result: any) => {
        this.manualList = this.toSelectItems(result);
      });
    this.subscriptions.push(manuals);
  }
  bindQsdetails() {
    this.qualityList = [];
    const quality = this.qualityservice
      .getQualitySystemDocumentTraining(BaseServices.BusinessId)
      .subscribe((result: any) => {
        this.qualityList = this.toSelectItems(result);
      });
    this.subscriptions.push(quality);
  }
  bindOsdetails() {
    this.otherList = [];
    const other = this.otherservice
      .getOtherSystemDocumentTraining(BaseServices.BusinessId)
      .subscribe((result: any) => {
        this.otherList = this.toSelectItems(result);
      });
    this.subscriptions.push(other);
  }

  bindICdetails() {
    this.internalControlList = [];
    const ic = this.internalControlService
      .getInternalControlDocumentTraining(BaseServices.BusinessId)
      .subscribe((result: any) => {
        this.internalControlList = this.toSelectItems(result);
      });
    this.subscriptions.push(ic);
  }
  SelectManual(manualId: number | null | undefined) {
    if (!manualId) return;
    this.treeNode = [];
    this.showArchiveDocumentDailog = false;
    this.selectingManual = true;
    this.dropDownAlinement = true;

    const onSuccess = (result: any[]) => {
      if (result && Array.isArray(result)) {
        // Filter logic: keep items that match the criteria OR include all if none match
        let filtered = result.filter(x => {
          const hasValidStatus = x.status == 1;
          const isNotExcludedId = x.id !== 10 && x.id !== 18;
          const isNotChecklist =
            !x.documentType || x.documentType !== 'checklist';
          return hasValidStatus && isNotExcludedId && isNotChecklist;
        });

        // If filtering removed everything, use original result as fallback
        this.treeNode =
          filtered.length > 0 ? filtered : result.filter(x => x.status == 1);
      } else {
        this.treeNode = [];
      }

      if (this.treeNode.length) this.nodeStatusChangeFunction(this.treeNode);

      this.showArchiveDocumentDailog = true; // show tree on success
      this.selectingManual = false;
      this.dropDownAlinement = false;
      this.cdr.detectChanges();
    };

    const onError = (error: any) => {
      console.error('Error loading manual tree:', error);
      this.showArchiveDocumentDailog = false;
      this.selectingManual = false;
      this.dropDownAlinement = false;
      this.cdr.detectChanges();
    };

    if (this.featureId === FeatureKey.MANUALS) {
      this.subscriptions.push(
        this.manualservices
          .getManualTreeBusinessLevel(manualId, BaseServices.BusinessId, false)
          .subscribe({ next: onSuccess, error: onError })
      );
    } else {
      this.subscriptions.push(
        this.featureManualService
          .getFeatureManualTreeBytree(this.featureId, manualId)
          .subscribe({ next: onSuccess, error: onError })
      );
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub, i) => {
      sub.unsubscribe();
    });
  }
  //#endregion
}
